<template>
  <div class="card m-3" style="max-height: 90vh;overflow: auto">
    <div class="card-header">
      <h2 align="left">
        {{ vizletTitleDpName ? vizletTitleDpName : 'CrissCross Analysis' }}
      </h2>
    </div>
    <div class="card-body">
      <!--            :renderers=renderers-->
      <vue-pivottable-ui
          v-model="config"
          :data="data"
          :localeStrings="localeStrings[locale]"
          :rendererName="rendererName"
          :aggregatorName="aggregatorName"
          :aggregators="aggregators"
          :tableColorScaleGenerator="colorScaleGenerator"
          :attributes="attributes"
          :valueFilter="valueFilter"
          :rows="rows"
          :cols="cols"
          :vals="vals"
          :disabledFromDragDrop="disabledFromDragDrop"
          :sortonlyFromDragDrop="sortonlyFromDragDrop"
          :hiddenFromDragDrop="hiddenFromDragDrop"
          :hiddenFromAggregators="hiddenFromAggregators"
          :sorters="sorters"
          rowOrder="value_a_to_z"
      >
        <colgroup slot="colGroup">
          <col :width="300">
          <col>
        </colgroup>
        <div v-if="loading" slot="output">
          loading...
        </div>
        <template v-if="!loading" slot="output" slot-scope="{ pivotData }">
          {{ pivotData }}
        </template>
        <template slot="pvtAttr" slot-scope="{ name }">
          {{ name }}
        </template>
      </vue-pivottable-ui>
    </div>
  </div>
</template>

<script>
import {PivotUtilities, Renderer, VuePivottableUi} from 'vue-pivottable'

import 'vue-pivottable/dist/vue-pivottable.css'
import {scaleLinear} from 'd3-scale'
import axios from "axios";

export default {
  components: {
    VuePivottableUi
    // VuePivottable
  },
  name: 'app',
  data() {
    return {
      // fix issue #27
      valueFilter: {
        Meal: {
          Dinner: true
        }
      },
      config: {},
      filteredData: [],
      data: [],
      vizletTitleDpName: '',
      // attributes: ['Retailer', 'Retailer Type', 'Territory', 'Salesperson', 'Product Category', 'Product Subcategory', 'Product Family', 'Product', 'Brand', 'Year-Month', 'Year-Quarter', 'Transactions', 'Units', 'Cost Amount', 'Sales Amount'],
      // rows: ['Retailer','Retailer Type'],
      // cols: ['Product Category', 'Product Subcategory'],
      // vals: ['Transactions'],
      attributes: [],
      rows: [],
      cols: [],
      vals: [],
      disabledFromDragDrop: [], // ['Payer Gender'],
      hiddenFromDragDrop: [],
      hiddenFromAggregators: [],
      // hiddenFromAggregators:['Retailer', 'Retailer Type', 'Territory', 'Salesperson', 'Product Category','Product Subcategory', 'Product Family', 'Product', 'Brand', 'Year-Month', 'Year-Quarter'],
      sortonlyFromDragDrop: [], // ['Party Size'],
      /*attributes:['Region', 'State', 'Loan Purpose', 'Loan Grade', 'Loan Issue Year', 'Loan Issue Month', 'Loan Sub Grade', 'Age Bucket', 'Loan Status', 'Loan Amount', 'Settlement Amount', 'Balance Amount'],
      rows: ['Loan Purpose'],
      cols: ['Region', 'State'],
      vals: ['Loan Amount'],
      disabledFromDragDrop: [], // ['Payer Gender'],
      hiddenFromDragDrop: ['Loan Amount', 'Settlement Amount', 'Balance Amount'],
      hiddenFromAggregators: ['Region', 'State', 'Loan Purpose', 'Loan Grade', 'Loan Issue Year', 'Loan Status', 'Loan Issue Month', 'Loan Sub Grade', 'Age Bucket'],
      sortonlyFromDragDrop: [],*/
      // pivotColumns: [],
      loading: false,
      aggregatorName: 'Sum',
      rendererName: 'Table',
      localeStrings: {
        en: {
          renderError: 'An error occurred rendering the PivotTable results.',
          computeError: 'An error occurred computing the PivotTable results.',
          uiRenderError: 'An error occurred rendering the PivotTable UI.',
          selectAll: 'Select All',
          selectNone: 'Select None',
          tooMany: 'too many values to show',
          filterResults: 'Filter values',
          totals: 'Totals',
          only: 'only',
          rendererNames: {
            Table: 'Table',
            'Table Heatmap': 'Table Heatmap',
            'Table Col Heatmap': 'Table Col Heatmap',
            'Table Row Heatmap': 'Table Row Heatmap',
            'Export Table TSV': 'Export Table TSV',
            'Grouped Column Chart': 'Grouped Column Chart',
            'Stacked Column Chart': 'Stacked Column Chart',
            'Grouped Bar Chart': 'Grouped Bar Chart',
            'Stacked Bar Chart': 'Stacked Bar Chart',
            'Line Chart': 'Line Chart',
            'Dot Chart': 'Dot Chart',
            'Area Chart': 'Area Chart',
            'Scatter Chart': 'Scatter Chart',
            'Multiple Pie Chart': 'Multiple Pie Chart'
          },
          aggregatorMap: {
            Count: 'Count',
            'Count Unique Values': 'Count Unique Values',
            'List Unique Values': 'List Unique Values',
            Sum: 'Sum',
            'Integer Sum': 'Integer Sum',
            Average: 'Average',
            Median: 'Median',
            'Sample Variance': 'Sample Variance',
            'Sample Standard Deviation': 'Sample Standard Deviation',
            Minimum: 'Minimum',
            Maximum: 'Maximum',
            First: 'First',
            Last: 'Last',
            'Sum over Sum': 'Sum over Sum',
            'Sum as Fraction of Total': 'Sum as Fraction of Total',
            'Sum as Fraction of Rows': 'Sum as Fraction of Rows',
            'Sum as Fraction of Columns': 'Sum as Fraction of Columns',
            'Count as Fraction of Total': 'Count as Fraction of Total',
            'Count as Fraction of Rows': 'Count as Fraction of Rows',
            'Count as Fraction of Columns': 'Count as Fraction of Columns'
          }
        }
      },
      locale: 'en'
    }
  },
  created() {
    this.listenToRouter();
    this.loadPage();

  },
  computed: {
    sorters() {
      return {
        'Day of Week': PivotUtilities.sortAs(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'])
      }
    },
    unusedAttrs() {
      return this.config.unusedAttrs
    },

    renderers() {
      const TableRenderer = Renderer.TableRenderer
      // const PlotlyRenderer = Renderer.PlotlyRenderer
      return (() => ({
            'Table': TableRenderer.Table,
            'Table Heatmap': TableRenderer['Table Heatmap']/*,
            'Table Col Heatmap': TableRenderer['Table Col Heatmap'],
            'Table Row Heatmap': TableRenderer['Table Row Heatmap'],
            'Export Table TSV': TableRenderer['Export Table TSV']*/
          })
      )()
    },
    aggregators() {
      const usFmt = PivotUtilities.numberFormat()
      const usFmtInt = PivotUtilities.numberFormat({digitsAfterDecimal: 0})
      // const usFmtPct = PivotUtilities.numberFormat({
      //   digitsAfterDecimal: 1,
      //   scaler: 100,
      //   suffix: '%'
      // })
      return ((tpl) => ({
            'Count': tpl.count(usFmtInt),
            'Count Unique Values': tpl.countUnique(usFmtInt),
            'List Unique Values': tpl.listUnique(', '),
            Sum: tpl.sum(usFmt),
            'Integer Sum': tpl.sum(usFmtInt),
            'Average': tpl.average(usFmt), //,
            'Median': tpl.median(usFmt),
            'Sample Variance': tpl.var(1, usFmt),
            // 'Sample Standard Deviation': tpl.stdev(1, usFmt),
            // 'Minimum': tpl.min(usFmt),
            // 'Maximum': tpl.max(usFmt),
            // 'First': tpl.first(usFmt),
            // 'Last': tpl.last(usFmt),
            // 'Sum over Sum': tpl.sumOverSum(usFmt),
            // 'Sum as Fraction of Total': tpl.fractionOf(tpl.sum(), 'total', usFmtPct),
            // 'Sum as Fraction of Rows': tpl.fractionOf(tpl.sum(), 'row', usFmtPct),
            // 'Sum as Fraction of Columns': tpl.fractionOf(tpl.sum(), 'col', usFmtPct),
            // 'Count as Fraction of Total': tpl.fractionOf(tpl.count(), 'total', usFmtPct),
            // 'Count as Fraction of Rows': tpl.fractionOf(tpl.count(), 'row', usFmtPct),
            // 'Count as Fraction of Columns': tpl.fractionOf(tpl.count(), 'col', usFmtPct)
          })
      )(PivotUtilities.aggregatorTemplates)
    }
  },
  methods: {
    colorScaleGenerator(values) {
      const scale = scaleLinear()
          .domain([0, Math.max.apply(null, values)])
          .range(['#fff', '#77f'])
      return x => {
        return {'background-color': scale(x)}
      }
    },
    loadPage() {

      let submenuParam = this.$route.params.submenuId
      let allVizData = this.$store.state.fwConfigScreenElement
      let curScrData = allVizData.filter(r => r.menuId === submenuParam)
      this.vizletTitleDpName = curScrData[0].vizletTitleDpName
      this.attributes = curScrData[0].reportHeaderColumnDp.attributes
      this.cols = curScrData[0].reportHeaderColumnDp.cols
      this.rows = curScrData[0].reportHeaderColumnDp.rows
      this.vals = curScrData[0].reportHeaderColumnDp.vals
      this.hiddenFromAggregators = curScrData[0].reportHeaderColumnDp.hiddenFromAggregators
      let datasqlId = curScrData[0].datasqlId
      // setTimeout(this.loadData(datasqlId),1000) ;
      this.loadData(datasqlId);
      console.log("Visualization Data", datasqlId, curScrData, submenuParam, this.attributes, this.cols, this.rows, this.vals, this.hiddenFromAggregators)

    },
    loadData(sqlId) {
      setTimeout(() => {
        // this.data = tips
        let url = '/api/fetchDataWithParam/' + sqlId + '/Any'
        /*axios({ url: url, baseURL: '', method: 'GET' }).then(res => {
       /!* axios({ url: '/json/bank_data.json', baseURL: '', method: 'GET' }).then(res => {*!/
          this.data= res.data
        })*/
        axios.post(url, {}).then(res => {
          this.data = res.data.rowsData;
          console.log("Pivot Json data", this.data)
        })
      }, 1000)
    },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.data = []
        setTimeout(() => {
          $this.loadPage()
          //$this.loadSummary($this.x)
        }, 300)

      })
    }
  },
  watch: {
    config: {
      handler(value) {
        const PivotData = PivotUtilities.PivotData
        // this.data = tips
        this.filteredData = new PivotData(value).getFilteredData()
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style>
.main {
  max-width: 980px;
  margin: 8vh auto 20px;
}

.title {
  text-align: center;
  margin-bottom: 20px;
}

h1 {
  margin-bottom: 0px;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  max-height: 60vh;
}

pre {
  text-align: left;
  background-color: #f8f8f8;
  padding: 1.2em 1.4em;
  line-height: 1.5em;
  margin: 60px 0 0;
  overflow: auto;
}

code {
  padding: 0;
  margin: 0;
}

footer {
  text-align: center;
  margin-top: 40px;
  line-height: 2;
}

.pvtOutput div{
  max-height: 55vh;     /* adjust as needed */
  overflow: auto;       /* enables both scrollbars */
}

.pvtTable {
  min-width: max-content; /* forces horizontal scroll */
}
</style>
